import { GripVertical, Trash2 } from "lucide-react";
import { Button } from "@/shared/ui/button";
import { Input } from "@/shared/ui/input";
import type { ValueItem } from "./types";

interface ValueInputRowProps {
  valueItem: ValueItem;
  index: number;
  draggedIndex: number | null;
  dragOverIndex: number | null;
  onValueChange: (id: string, value: string) => void;
  onRemove: (id: string) => void;
  onDragStart: (index: number) => void;
  onDragOver: (e: React.DragEvent, index: number) => void;
  onDrop: (e: React.DragEvent, index: number) => void;
  onDragEnd: () => void;
  canRemove: boolean;
}

export function ValueInputRow({
  valueItem,
  index,
  draggedIndex,
  dragOverIndex,
  onValueChange,
  onRemove,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  canRemove,
}: ValueInputRowProps) {
  const isDragging = draggedIndex === index;
  const isDragOver = dragOverIndex === index && draggedIndex !== index;

  return (
    <div
      draggable
      onDragStart={() => onDragStart(index)}
      onDragOver={(e) => onDragOver(e, index)}
      onDrop={(e) => onDrop(e, index)}
      onDragEnd={onDragEnd}
      className={`flex items-center gap-2 transition-opacity ${
        isDragging ? "opacity-50" : ""
      } ${isDragOver ? "bg-grid-100 rounded-md" : ""}`}
    >
      <GripVertical className="h-5 w-5 text-ink-400 cursor-grab active:cursor-grabbing" />
      <Input
        value={valueItem.value}
        onChange={(event) => onValueChange(valueItem.id, event.target.value)}
        placeholder={`Value ${index + 1}`}
        className="flex-1"
      />
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={() => onRemove(valueItem.id)}
        className="h-8 w-8 text-red-600 hover:text-red-700 hover:bg-red-50"
        disabled={!canRemove}
      >
        <Trash2 className="h-4 w-4" />
        <span className="sr-only">Delete value</span>
      </Button>
    </div>
  );
}

